/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { ESpotContainerType } from '@/data/types/ESpot';
import { processMarketingContent } from '@/data/utils/processMarketingContent';
type ContentTypeArray = {
	title: string;
	url: string;
};
type IconTypeArray = {
	icon: string;
	url: string;
};
type TyCTypeArray = {
	text: string;
	url: string;
};
type NewsletterType = {
	title: string;
	subtitle: string;
};
export type ContactType = {
	icon: string;
	url: string;
	title: string;
	subtitle: string;
};

export type JsonEspotResponseType = {
	title: string;
	contents?: ContentTypeArray[];
	copyright?: string;
	icons?: IconTypeArray[];
	tyc?: TyCTypeArray[];
	newsletter: NewsletterType;
	slogan?: string;
	contacts?: ContactType[];
};
export const dataMapJsonContent = (contents?: ESpotContainerType) => {
	const data = contents?.MarketingSpotData?.at(0)
		?.baseMarketingSpotActivityData?.map(processMarketingContent)
		.map((content) => {
			if (!content.text) return content.text;

			try {
				return JSON.parse(content.text);
			} catch {
				return content.text;
			}
		})?.[0];

	return data as JsonEspotResponseType;
};
// contents?.MarketingSpotData?.at(0)?.baseMarketingSpotActivityData?.map(processMarketingContent);
export const dataMapContent = (contents?: ESpotContainerType) => {
	const activities = contents?.MarketingSpotData?.at(0)?.baseMarketingSpotActivityData;

	if (!activities || activities?.length === 0) {
		return undefined;
	}

	const referenceId = activities[0]?.activityIdentifierID;
	const validContent = activities?.filter(
		(activity) => activity?.activityIdentifierID === referenceId
	);

	if (validContent.length === 0) {
		return undefined;
	}

	return validContent.map(processMarketingContent);
};

export const dataMapTitleContent = (contents?: ESpotContainerType) =>
	contents?.MarketingSpotData?.at(0)?.marketingSpotDataTitle?.map(processMarketingContent);

export const dataMapESpotName = (contents?: ESpotContainerType) =>
	contents?.MarketingSpotData?.at(0)?.eSpotName;
